import React from "react";
import { BusinessOperationResponse } from "../../Types/BusinessOperationTypes";
import BaseBusinessResultPage from "../BaseBusinessPageResult";

const BusinessEnrolmentDetailPageResult: React.FC<{
  response: BusinessOperationResponse;
}> = ({ response }) => <BaseBusinessResultPage response={response} operationType="enrol" />;

export default BusinessEnrolmentDetailPageResult;
